import type { TranslatableField, TranslatedString } from './types';

export const DEFAULT_TARGET_LANG = 'en';

export function isEnglish(lang: string | undefined): boolean {
  if (!lang) return true;
  const normalised = lang.trim().toLowerCase();
  return normalised === '' || normalised === 'english' || normalised === 'en';
}

export function hasContent(s: string | null | undefined): s is string {
  return typeof s === 'string' && s.trim().length > 0;
}

function isTranslatedString(v: unknown): v is TranslatedString {
  return typeof v === 'object' && v !== null && typeof (v as { text?: unknown }).text === 'string';
}

export function resolveTranslated(
  field: TranslatableField | null | undefined,
  showTranslated: boolean,
  target: string = DEFAULT_TARGET_LANG,
): string {
  if (field == null) return '';
  if (typeof field === 'string') return field;
  if (!isTranslatedString(field)) return '';
  const translated = field.translations?.[target];
  if (showTranslated && hasContent(translated)) {
    return translated;
  }
  return field.text;
}
